// ======================================================================
// File Name       : TabMenuContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Row, Tab, Tabs } from 'react-bootstrap';
import { connect } from 'react-redux';
import { saveActiveTabMenu } from '../actions/TabMenuAction';
import { saveReportActiveTabMenu } from '../actions/TabMenuReportAction';
import Header from '../components/Header';
import CustomButton from '../components/button/CustomButton';
import CustomLink from '../components/button/CustomLink';
import { LO_SUPER_USER, READ, SUPER_USER, USAGE_SETTING, CERTIFICATE_COMPLETION_URL } from '../constants';
import * as AuthorityConstant from '../constants/AuthorityConstant';
import * as ICON from '../constants/IconConstants';
import * as Path from '../constants/PathConstants';
import ContentDocumentContainer from '../containers/content/ContentDocumentContainer';
import ContentDrillContainer from '../containers/content/ContentDrillContainer';
import ContentLinkListContainer from '../containers/content/ContentLinkListContainer';
import ContentQuestionListContainer from '../containers/content/ContentQuestionListContainer';
import ContentVideoContainer from '../containers/content/ContentVideoContainer';
import ReceivedMessageListContainer from '../containers/messageThread/ReceivedMessageListContainer';
import SentMessageListContainer from '../containers/messageThread/SentMessageListContainer';
import { isSuperUser } from '../utils';
import { checkIsShowTabMenu } from '../utils/PageUtils';
import ArchivementListContainer from './archivement/ArchivementListContainer';
import EmailListContainer from './email/EmailListContainer';
import ReservedEmailListContainer from './email/ReservedEmailListContainer';
import LivePerformanceListContainer from './livePerformance/LivePerformanceListContainer';
import MultiLanguageListContainer from './multiLanguage/MultiLanguageListContainer';
import MultiLanguageProcessResultListContainer from './multiLanguage/MultiLanguageProcessResultListContainer';
import DistributionReportContainer from './report/distribution/DistributionReportContainer';
import ScoringReportTabMenuContainer from './report/scoring/ScoringReportTabMenuContainer';
import UnsubmittedReportContainer from './report/unsubmitted/UnsubmittedReportContainer';
import ServiceRecordContainer from './service/ServiceRecordContainer';
import LiveReservedListContainer from './usageSettingLive/LiveReservedListContainer';
import ContentHistoryListContainer from './userHistory/content/ContentHistoryListContainer';
import UserHistoryCourseTopContainer from './userHistory/course/UserHistoryCourseTopContainer';
import CourseDefaultThumbnailContainer  from './course/CourseDefaultThumbnailContainer';
import ParticipantListContainer from './userHistory/participant/ParticipantListContainer';
import UserHistoryStudentTopContainer from './userHistory/student/UserHistoryStudentTopContainer';
import UserfrontLoginScreenContainer from './userfront/UserfrontLoginScreenContainer';
import UserfrontTopScreenContainer from './userfront/UserfrontTopScreenContainer';
import ServiceSystemUsageListContainer from './service/ServiceSystemUsageListContainer';
import SuperuserEnterpriseRoleTopContainer from './superuserEnterpriseRole/SuperuserEnterpriseRoleTopContainer';
import SuperuserServiceRoleTopContainer from './superuserServiceRole/SuperuserServiceRoleTopContainer';
import { SERVICE_TYPE } from '../constants/ServiceConstant';
import * as SessionStorageUtils from '../utils/SessionStorageUtils';
import { CONTENT_TYPE_STR } from "../constants/ContentConstant";
import { MANAGEMENT_AUTHORITY_TYPE } from '../constants/AuthorityConstant';

class TabMenuContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      headerTitle: '',
      titleList: [],
      componentList: [],
      isInit: true,
    };
    this.handleSelectTab = this.handleSelectTab.bind(this);
    this.resetActiveTab = this.resetActiveTab.bind(this);
  }

  componentDidMount() {
    const { match, authedUser } = this.props;
    const {
      userInfo,
      usageSettingLive,
      usageSettingVideo,
      managementFunctionAuthorityInfo,
      serviceType,
      enterpriseManagementFunctionAuthorityInfo,
      serviceCd,
      usageSettingSufCustomize,
      loginSuperuserEnterpriseRoleSecernId,
      hasSubEnterprise, // Step 11.0.0
    } = authedUser;
    const isSuperUserL0 = [LO_SUPER_USER].indexOf(userInfo.displayUserType) > -1;
    const isSuperuser = [SUPER_USER].indexOf(userInfo.displayUserType) > -1;
    const isContentDistributionService = serviceType === SERVICE_TYPE.CONTENT_DISTRIBUTION;

    let scoringManagementAuthority;
    if (managementFunctionAuthorityInfo && managementFunctionAuthorityInfo.scoringManagementAuthority) {
      scoringManagementAuthority = managementFunctionAuthorityInfo.scoringManagementAuthority;
    }

    if (match.url === Path.CONTENT_LIST) {
      const { showContentsOnly } = SessionStorageUtils.getUserQuery();
      switch (showContentsOnly) {
        case CONTENT_TYPE_STR.VIDEO:
        case CONTENT_TYPE_STR.DOCUMENT:
        case CONTENT_TYPE_STR.LINK:
          if (usageSettingVideo === USAGE_SETTING.USE) {
            this.setState({
              headerTitle: 'コンテンツ',
              eventKeyList: [Path.CONTENT_VIDEO_LIST, Path.CONTENT_DOCUMENT_LIST, Path.CONTENT_LINK_LIST],
              iconList: [ICON.TAB_VIDEO, ICON.TAB_DOCUMENT, ICON.TAB_LINK],
              iconActiveList: [ICON.TAB_VIDEO_ACTIVE, ICON.TAB_DOCUMENT_ACTIVE, ICON.TAB_LINK_ACTIVE],
              titleList: ['ビデオ', 'ドキュメント', 'リンク'],
              componentList: [<ContentVideoContainer />, <ContentDocumentContainer />, <ContentLinkListContainer />],
            });
          } else {
            this.setState({
              headerTitle: 'コンテンツ',
              eventKeyList: [Path.CONTENT_DOCUMENT_LIST, Path.CONTENT_LINK_LIST],
              iconList: [ICON.TAB_DOCUMENT, ICON.TAB_LINK],
              iconActiveList: [ICON.TAB_DOCUMENT_ACTIVE, ICON.TAB_LINK_ACTIVE],
              titleList: ['ドキュメント', 'リンク'],
              componentList: [<ContentDocumentContainer />, <ContentLinkListContainer />],
            });
          }
          break;
        case CONTENT_TYPE_STR.DRILL:
          this.setState({
            headerTitle: 'ドリル',
            eventKeyList: [Path.CONTENT_DRILL_LIST, Path.CONTENT_QUESTION_LIST],
            iconList: [ICON.TAB_DRILL, ICON.TAB_QUESTION],
            iconActiveList: [ICON.TAB_DRILL_ACTIVE, ICON.TAB_QUESTION_ACTIVE],
            titleList: ['ドリル一覧', '問題一覧'],
            componentList: [<ContentDrillContainer />, <ContentQuestionListContainer />],
          });
          break;
        default:
          break;
      }
    }

    switch (match.url) {
      case Path.CONTENT_DRILL_LIST:
      case Path.CONTENT_QUESTION_LIST:
        this.setState({
          headerTitle: 'ドリル',
          eventKeyList: [Path.CONTENT_DRILL_LIST, Path.CONTENT_QUESTION_LIST],
          iconList: [ICON.TAB_DRILL, ICON.TAB_QUESTION],
          iconActiveList: [ICON.TAB_DRILL_ACTIVE, ICON.TAB_QUESTION_ACTIVE],
          titleList: ['ドリル一覧', '問題一覧'],
          componentList: [<ContentDrillContainer />, <ContentQuestionListContainer />],
        });
        break;
      case Path.SENT_MESSAGE_LIST:
      case Path.RECEIVED_MESSAGE_LIST:
        this.setState({
          headerTitle: 'メッセージ管理',
          eventKeyList: [Path.SENT_MESSAGE_LIST, Path.RECEIVED_MESSAGE_LIST],
          iconList: [ICON.TAB_SENT_MESSAGE, ICON.TAB_RECEIVED_MESSAGE],
          iconActiveList: [ICON.TAB_SENT_MESSAGE_ACTIVE, ICON.TAB_RECEIVED_MESSAGE_ACTIVE],
          titleList: ['スレッド一覧', '受信ボックス'],
          componentList: [<SentMessageListContainer />, <ReceivedMessageListContainer />],
        });
        break;
      case Path.CONTENT_LINK_LIST:
      case Path.CONTENT_DOCUMENT_LIST:
      case Path.CONTENT_VIDEO_LIST:
        if (usageSettingVideo === USAGE_SETTING.USE) {
          this.setState({
            headerTitle: 'コンテンツ',
            eventKeyList: [Path.CONTENT_VIDEO_LIST, Path.CONTENT_DOCUMENT_LIST, Path.CONTENT_LINK_LIST],
            iconList: [ICON.TAB_VIDEO, ICON.TAB_DOCUMENT, ICON.TAB_LINK],
            iconActiveList: [ICON.TAB_VIDEO_ACTIVE, ICON.TAB_DOCUMENT_ACTIVE, ICON.TAB_LINK_ACTIVE],
            titleList: ['ビデオ', 'ドキュメント', 'リンク'],
            componentList: [<ContentVideoContainer />, <ContentDocumentContainer />, <ContentLinkListContainer />],
          });
        } else {
          this.setState({
            headerTitle: 'コンテンツ',
            eventKeyList: [Path.CONTENT_DOCUMENT_LIST, Path.CONTENT_LINK_LIST],
            iconList: [ICON.TAB_DOCUMENT, ICON.TAB_LINK],
            iconActiveList: [ICON.TAB_DOCUMENT_ACTIVE, ICON.TAB_LINK_ACTIVE],
            titleList: ['ドキュメント', 'リンク'],
            componentList: [<ContentDocumentContainer />, <ContentLinkListContainer />],
          });
        }

        break;
      case Path.USER_HISTORY_COURSE_LIST:
      case Path.USER_HISTORY_STUDENT_LIST:
      case Path.USER_HISTORY_CONTENT_LIST:
        this.setState({
          headerTitle: '学習履歴',
          eventKeyList: [Path.USER_HISTORY_COURSE_LIST, Path.USER_HISTORY_STUDENT_LIST, Path.USER_HISTORY_CONTENT_LIST],
          iconList: [
            ICON.TAB_LEARNING_HISTORY_COURSE,
            ICON.TAB_LEARNING_HISTORY_USER,
            ICON.TAB_LEARNING_HISTORY_CONTENT,
          ],
          iconActiveList: [
            ICON.TAB_LEARNING_HISTORY_COURSE_ACTIVE,
            ICON.TAB_LEARNING_HISTORY_USER_ACTIVE,
            ICON.TAB_LEARNING_HISTORY_CONTENT_ACTIVE,
          ],
          titleList: ['コース別', 'ユーザー別', 'コンテンツ別'],
          componentList: [
            <UserHistoryCourseTopContainer />,
            <UserHistoryStudentTopContainer />,
            <ContentHistoryListContainer />,
          ],
          isLearningHistory: true,
        });
        break;
      case Path.EMAIL_LIST:
      case Path.RESERVED_EMAIL_LIST:
        this.setState({
          headerTitle: 'メール連絡',
          eventKeyList: [Path.EMAIL_LIST, Path.RESERVED_EMAIL_LIST],
          iconList: [
            ICON.TAB_SEND_EMAIL,
            ICON.NONE_ICON,
          ],
          iconActiveList: [
            ICON.TAB_SEND_EMAIL_ACTIVE,
            ICON.NONE_ICON,
          ],
          titleList: ['送信メール一覧', '予約中'],
          componentList: [<EmailListContainer />, <ReservedEmailListContainer />],
        });
        break;
      case Path.USERFRONT_LOGIN_SCREEN_UPDATE:
      case Path.USERFRONT_TOP_SCREEN_UPDATE:
      case Path.COURSE_THUMBNAIL_UPDATE:
      case Path.USERFRONT_CERTIFICATE_COMPLETION:
        if (isContentDistributionService || usageSettingSufCustomize === USAGE_SETTING.USE) {
          this.setState({
            headerTitle: '受講ユーザー画面管理',
            eventKeyList: [Path.COURSE_THUMBNAIL_UPDATE],
            iconList: [
              ICON.NONE_ICON,
            ],
            iconActiveList: [
              ICON.NONE_ICON,
            ],
            titleList: ['各種サムネイル'],
            componentList: [<CourseDefaultThumbnailContainer />],
          });
        } else {
          this.setState({
            headerTitle: "受講ユーザー画面管理",
            eventKeyList: [
              Path.USERFRONT_LOGIN_SCREEN_UPDATE,
              Path.USERFRONT_TOP_SCREEN_UPDATE,
              Path.COURSE_THUMBNAIL_UPDATE,
              Path.USERFRONT_CERTIFICATE_COMPLETION,
            ],
            iconList: [
              ICON.TAB_SEND_EMAIL,
              ICON.TAB_RESERVATION_EMAIL,
              ICON.NONE_ICON,
              ICON.NONE_ICON,
            ],
            iconActiveList: [
              ICON.TAB_SEND_EMAIL_ACTIVE,
              ICON.TAB_RESERVATION_EMAIL_ACTIVE,
              ICON.NONE_ICON,
              ICON.NONE_ICON,
            ],
            titleList: [
              "ログイン画面",
              "ログイン後トップ画面",
              "各種サムネイル",
              "修了証",
            ],
            componentList: [
              <UserfrontLoginScreenContainer />,
              <UserfrontTopScreenContainer />,
              <CourseDefaultThumbnailContainer />,
              <div />,
            ],
          });
        }
        break;
      case Path.LIVE_RESERVED_LIST:
      case Path.PARTICIPANT_LIST:
      case Path.USER_HISTORY_LIVE_PERFORMANCE_LIST:
        if (usageSettingLive === USAGE_SETTING.USE) {
          this.setState({
            headerTitle: 'ライブ管理',
            eventKeyList: [Path.LIVE_RESERVED_LIST, Path.USER_HISTORY_LIVE_PERFORMANCE_LIST, Path.PARTICIPANT_LIST],
            iconList: [
              ICON.TAB_QUESTION,
              ICON.TAB_QUESTION,
              ICON.TAB_QUESTION,
            ],
            iconActiveList: [
              ICON.TAB_QUESTION_ACTIVE,
              ICON.TAB_QUESTION_ACTIVE,
              ICON.TAB_QUESTION_ACTIVE,
            ],
            titleList: ['ライブ一覧', 'ライブ別実績', 'ユーザー別実績'],
            componentList: [<LiveReservedListContainer />, <LivePerformanceListContainer />, <ParticipantListContainer />],
          });
        } else {
          this.setState({
            headerTitle: 'ライブ管理',
            eventKeyList: [Path.USER_HISTORY_LIVE_PERFORMANCE_LIST, Path.PARTICIPANT_LIST],
            iconList: [
              ICON.TAB_QUESTION,
              ICON.TAB_QUESTION,
            ],
            iconActiveList: [
              ICON.TAB_QUESTION_ACTIVE,
              ICON.TAB_QUESTION_ACTIVE,
            ],
            titleList: ['ライブ別実績', 'ユーザー別実績'],
            componentList: [<LivePerformanceListContainer />, <ParticipantListContainer />],
          });
        }
        break;
      case Path.MULTI_LANGUAGE_LIST:
      case Path.MULTI_LANGUAGE_PROCESS_RESULT_LIST:
        this.setState({
          headerTitle: '多言語対応',
          eventKeyList: [Path.MULTI_LANGUAGE_LIST, Path.MULTI_LANGUAGE_PROCESS_RESULT_LIST],
          iconList: [
            ICON.TAB_DOCUMENT,
            ICON.NONE_ICON,
          ],
          iconActiveList: [
            ICON.TAB_DOCUMENT_ACTIVE,
            ICON.NONE_ICON,
          ],
          titleList: ['対応済みドキュメント', '処理結果一覧'],
          componentList: [<MultiLanguageListContainer />, <MultiLanguageProcessResultListContainer />],
          isMultiLang: true,
        });
        break;
      case Path.SERVICE_RECORD_COMPANY_LIST:
      case Path.SERVICE_RECORD_SERVICE_LIST:
      case Path.SERVICE_RECORD_SERVICES_LIST: // Step 12.3.0 TAS-21359
      case Path.SERVICE_RECORD_DOWNLOAD_FORM:
        this.setState(
          this.setUpTabMenuSystemUsageRecord(
            isSuperuser,
            isSuperUserL0,
            serviceCd,
            managementFunctionAuthorityInfo,
            enterpriseManagementFunctionAuthorityInfo,
            hasSubEnterprise, // Step 11.0.0
          ),
        );
        break;
      case Path.SCORING_REPORT_TOP:
      case Path.SCORING_REPORT_LIST:
      case Path.SCORING_REPORT_GET:
      case Path.SCORING_REPORT_CORRECTION:
      case Path.SCORING_REPORT_WITHDRAWAL:
      case Path.SCORING_REPORT_APPROVAL:
      case Path.SCORING_REPORT_REMAND:
      case Path.SCORING_REPORT_COLLECTION:
      case Path.SCORING_UNSUBMITTED_LIST:
      case Path.SCORING_DISTRIBUTION_REPORT:
      case Path.SCORING_ARCHIVEMENT_LIST:
        if (scoringManagementAuthority === AuthorityConstant.SCORING_MANAGEMENT_AUTHORITY_TYPE.SCORING_APPROVAL) {
          this.setState({
            headerTitle: '添削管理',
            eventKeyList: [Path.SCORING_REPORT_TOP, Path.SCORING_UNSUBMITTED_LIST, Path.SCORING_DISTRIBUTION_REPORT, Path.SCORING_ARCHIVEMENT_LIST],
            iconList: [
              ICON.TAB_QUESTION,
              ICON.TAB_QUESTION,
              ICON.TAB_QUESTION,
              ICON.TAB_QUESTION,
            ],
            iconActiveList: [
              ICON.TAB_QUESTION_ACTIVE,
              ICON.TAB_QUESTION_ACTIVE,
              ICON.TAB_QUESTION_ACTIVE,
              ICON.TAB_QUESTION_ACTIVE,
            ],
            titleList: ['提出済みレポート', '未提出レポート', 'レポート分配', '添削者別実績'],
            componentList: [<ScoringReportTabMenuContainer {...this.props} />, <UnsubmittedReportContainer />, <DistributionReportContainer />, <ArchivementListContainer />],
          });
        } else {
          this.setState({
            headerTitle: '添削管理',
            eventKeyList: [Path.SCORING_REPORT_TOP],
            iconList: [
              ICON.TAB_QUESTION,
            ],
            iconActiveList: [
              ICON.TAB_QUESTION_ACTIVE,
            ],
            titleList: ['提出済みレポート'],
            componentList: [<ScoringReportTabMenuContainer {...this.props} />],
          });
        }
        break;
      // Step 11.0.0 START
      case Path.SUPERUSER_ENTERPRISE_ROLE_LIST:
      case Path.SUPERUSER_SERVICE_ROLE_LIST:
        if (loginSuperuserEnterpriseRoleSecernId === AuthorityConstant.SUPERUSER_ENTERPRISE_ROLE.SERVICE_ADMIN) {
          this.setState({
            headerTitle: 'ロールと権限',
            eventKeyList: [Path.SUPERUSER_SERVICE_ROLE_LIST],
            iconList: [
              ICON.NONE_ICON,
            ],
            iconActiveList: [
              ICON.NONE_ICON,
            ],
            titleList: ['サービスロール'],
            componentList: [<SuperuserServiceRoleTopContainer />],
          });
        } else {
          this.setState({
            headerTitle: 'ロールと権限',
            eventKeyList: [Path.SUPERUSER_ENTERPRISE_ROLE_LIST, Path.SUPERUSER_SERVICE_ROLE_LIST],
            iconList: [
              ICON.NONE_ICON,
              ICON.NONE_ICON,
            ],
            iconActiveList: [
              ICON.NONE_ICON,
              ICON.NONE_ICON,
            ],
            titleList: ['企業ロール', 'サービスロール'],
            componentList: [<SuperuserEnterpriseRoleTopContainer />, <SuperuserServiceRoleTopContainer />],
          });
        }
        break;
      // Step 11.0.0 END
      default:
        break;
    }

    this.setState({ isInit: false });
    this.resetActiveTab(match.url);
  }

  setUpTabMenuSystemUsageRecord(
    isSuperuser,
    isSuperUserL0,
    serviceCd,
    managementFunctionAuthorityInfo,
    enterpriseManagementFunctionAuthorityInfo,
    hasSubEnterprise, // Step 11.0.0
  ) {
    const systemRecordTabTitle = hasSubEnterprise ? '企業別' : '全体'; // Step 11.0.0
    let systemUsageRecordManagement = { // show all tab menus when initial
      headerTitle: 'システム利用実績',
      eventKeyList: [
        Path.SERVICE_RECORD_COMPANY_LIST,
        Path.SERVICE_RECORD_SERVICE_LIST,
        Path.SERVICE_RECORD_SERVICES_LIST,
        Path.SERVICE_RECORD_DOWNLOAD_FORM,
      ],
      iconList: [ICON.NONE_ICON, ICON.NONE_ICON, ICON.NONE_ICON, ICON.NONE_ICON],
      iconActiveList: [ICON.NONE_ICON, ICON.NONE_ICON, ICON.NONE_ICON, ICON.NONE_ICON],
      titleList: [systemRecordTabTitle, 'サービス別', 'サービス一覧', '帳票ダウンロード'],
      componentList: [
        <ServiceRecordContainer {...this.props} />,
        <ServiceRecordContainer {...this.props} />,
        <ServiceRecordContainer {...this.props} />,
        <ServiceSystemUsageListContainer />,
      ],
    };
    if (isSuperuser) { // not show 帳票ダウンロード if superuser L1 login
      systemUsageRecordManagement.eventKeyList = [Path.SERVICE_RECORD_COMPANY_LIST, Path.SERVICE_RECORD_SERVICE_LIST, Path.SERVICE_RECORD_SERVICES_LIST];
      systemUsageRecordManagement.titleList = [systemRecordTabTitle, 'サービス別', 'サービス一覧'];
      systemUsageRecordManagement.componentList = [
        <ServiceRecordContainer {...this.props} />,
        <ServiceRecordContainer {...this.props} />,
        <ServiceRecordContainer {...this.props} />,
      ];
    }
    if (serviceCd) { // SU login service or admin login
      if (managementFunctionAuthorityInfo.performanceManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.NOT_USED) { // not show サービス別
        if (isSuperUserL0) {
          systemUsageRecordManagement.eventKeyList = [
            Path.SERVICE_RECORD_COMPANY_LIST,
            Path.SERVICE_RECORD_DOWNLOAD_FORM,
          ];
          systemUsageRecordManagement.titleList = [systemRecordTabTitle, '帳票ダウンロード'];
          systemUsageRecordManagement.componentList = [
            <ServiceRecordContainer {...this.props} />,
            <ServiceSystemUsageListContainer />,
          ];
        } else if (isSuperuser) {
          systemUsageRecordManagement.eventKeyList = [Path.SERVICE_RECORD_COMPANY_LIST];
          systemUsageRecordManagement.titleList = [systemRecordTabTitle];
          systemUsageRecordManagement.componentList = [<ServiceRecordContainer {...this.props}/>];
        }
      } else if (
        managementFunctionAuthorityInfo.performanceManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE
        && enterpriseManagementFunctionAuthorityInfo
        && enterpriseManagementFunctionAuthorityInfo.enterprisePerformanceManagementAuthority
         === MANAGEMENT_AUTHORITY_TYPE.NOT_USED
      ) { // not show 全体 and 帳票ダウンロード
        systemUsageRecordManagement.eventKeyList = [Path.SERVICE_RECORD_SERVICE_LIST, Path.SERVICE_RECORD_SERVICES_LIST];
        systemUsageRecordManagement.titleList = ['サービス別', 'サービス一覧'];
        systemUsageRecordManagement.componentList = [<ServiceRecordContainer {...this.props}/>, <ServiceRecordContainer {...this.props}/>];
      }
    }
    return systemUsageRecordManagement;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { isInit } = this.state;
    const shouldNotUpdate = nextProps.location === this.props.location;
    return isInit ||!shouldNotUpdate ;
  }

  handleSelectTab(key) {
    const { dispatch, history } = this.props;
    history.replace({
      pathname: `${key}`,
    });
    dispatch(saveActiveTabMenu(key));
    if(key === Path.SCORING_REPORT_TOP) {
      dispatch(saveReportActiveTabMenu(key));
    }
  }

  resetActiveTab(url) {
    const { dispatch, history, activeTab, activeReportTab, location: { pathname } } = this.props;
    let key = url;
    if (activeTab === null) {
      const { showContentsOnly } = SessionStorageUtils.getUserQuery();
      switch (showContentsOnly) {
        case CONTENT_TYPE_STR.VIDEO:
          key = Path.CONTENT_VIDEO_LIST;
          break;
        case CONTENT_TYPE_STR.DOCUMENT:
          key = Path.CONTENT_DOCUMENT_LIST;
          break;
        case CONTENT_TYPE_STR.LINK:
          key = Path.CONTENT_LINK_LIST;
          break;
        case CONTENT_TYPE_STR.DRILL:
          key = Path.CONTENT_DRILL_LIST;
          break;  
        default:
          break;
      }
    }

    dispatch(saveActiveTabMenu(key));
    if (key === Path.SCORING_REPORT_TOP) {
      dispatch(saveReportActiveTabMenu(key));
    }
    if (
      activeReportTab === null &&
      (pathname === Path.SCORING_REPORT_TOP ||
        pathname === Path.SCORING_REPORT_GET ||
        pathname === Path.SCORING_REPORT_CORRECTION ||
        pathname === Path.SCORING_REPORT_WITHDRAWAL ||
        pathname === Path.SCORING_REPORT_APPROVAL ||
        pathname === Path.SCORING_REPORT_REMAND ||
        pathname === Path.SCORING_REPORT_COLLECTION)
    ) {
      history.replace({
        pathname: Path.SCORING_REPORT_TOP,
      });
    }
  }

  // Step 11.0.0 START
  goToCertificateCompletionPage(event) {
    event.stopPropagation();
    event.preventDefault();
    window.location.href = CERTIFICATE_COMPLETION_URL;
  }
  // Step 11.0.0 END

  render() {
    const { headerTitle, eventKeyList, iconList, iconActiveList, titleList, componentList, isLearningHistory, isMultiLang } = this.state;
    const { activeTab, history, authedUser: { userInfo, isTrialExpire, serviceNum } , match } = this.props;
    const isShowTabMenu = checkIsShowTabMenu(match.url, serviceNum);

    // Does not show tab menu if admin logged in and access システム利用実績管理
    if (!isSuperUser(userInfo.displayUserType) && match.url === Path.SERVICE_RECORD_SERVICE_LIST) {
      return (
        <>
          <Header name="サービス別システム利用実績情報の一覧" />
          <ServiceRecordContainer {...this.props} />
        </>
      );
    }

    let defaultActiveKey = '';
    if (eventKeyList) {
      if (activeTab && eventKeyList.indexOf(activeTab) > -1) {
        defaultActiveKey = activeTab;
      } else {
        defaultActiveKey = eventKeyList[0];
      }
    }

    const content = [];
    for (const i in eventKeyList) {
      const eventKey = eventKeyList[i];
      const tabIcon = eventKey === defaultActiveKey ? iconActiveList[i] : iconList[i];
      // Step 11.0.0 START
      if (eventKey === Path.USERFRONT_CERTIFICATE_COMPLETION) {
        content.push(
          <Tab
            title={
              <li onClick={this.goToCertificateCompletionPage}>
                {titleList[i]}
              </li>
            }
          >
          </Tab>
        );
      } else {
        content.push(
          <Tab
            key={eventKey}
            eventKey={eventKey}
            title={
              <div className={tabIcon}>
                {titleList[i]}
              </div>
            }
          >
            {eventKey === defaultActiveKey && (
              componentList[i]
            )}
          </Tab>
        );
      }
      // Step 11.0.0 END
    }
    return (
      <>
        {isMultiLang && !isTrialExpire && (
          <Col sm={12} className="padding-left-right-clear">
            <CustomLink
              className="margin-right-7 link-authority inline-flex"
              to={Path.CONTENT_DOCUMENT_LIST}
              text="ドキュメント一覧に戻る"
              icon="bi bi-chevron-left"
            />
          </Col>
        )}
        {!isLearningHistory && (
          <Col className="padding-left-right-clear">
              <Header name={headerTitle} />
          </Col>
        )}
        {isLearningHistory && (
          <Row sm={12} className="padding-left-right-clear">
            <Col sm={3} className="padding-left-right-clear">
              <Header name={headerTitle} />
            </Col>
            <Col sm={9} className="display-flex justify-content-end">
              <Col>
                <CustomButton
                  btnStyle="btn btn-export-csv float-end"
                  handleClick={() => { history.push(Path.LEARNING_HISTORY_CSV_DOWNLOAD); }}
                  iconClass="bi bi-download"
                  text="学習履歴CSV出力"
                />
              </Col>
              <Col xs="auto" className='margin-left-15'>
                <CustomButton
                  btnStyle="btn btn-export-csv float-end"
                  handleClick={() => { history.push(Path.PROGRESS_STATUS_CSV_DOWNLOAD); }}
                  iconClass="bi bi-download"
                  text="進捗状況CSV出力"
                />
              </Col>
            </Col>
          </Row>
        )}

        {isShowTabMenu && (
          <Tabs
            id="tab-container"
            activeKey={defaultActiveKey}
            defaultActiveKey={defaultActiveKey}
            onSelect={this.handleSelectTab}
          >
            {content}
          </Tabs>
        )}
        {!isShowTabMenu && componentList && componentList.length > 0 && (
          componentList[0]
        )}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { activeTab, activeReportTab } = state.tabMenu;
  const { authedUser } = state.authed;
  const { reloadComponent } = state.page;
  const { recordNum } = state.serviceRecord.serviceInfo;
  return {
    activeTab,
    activeReportTab,
    authedUser,
    reloadComponent,
  };
};
export default connect(mapStateToProps)(TabMenuContainer);
